import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import {store} from './app/store/store'
import TheMask from 'vue-the-mask'
import money from 'v-money'



/*
Internos
*/
import router from './router'

Vue.config.productionTip = false;
Vue.use(TheMask);
Vue.use(money, {precision: 2});

Vue.prototype.$globalformmasks = {                                 
                                  money_2p: {
                                    decimal: ',',
                                    thousands: '.',
                                    prefix: '',
                                    suffix: '',
                                    precision: 2,
                                    masked: false
                                  },
                                  money_9p: {
                                    decimal: ',',
                                    thousands: '.',
                                    prefix: '',
                                    suffix: '',
                                    precision: 9,
                                    masked: false
                                  }
                              };

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
